import { css } from "styled-components/macro";
import sizes from "./breakpoints";

export default Object.keys(sizes).reduce((acc: { [key: string]: any }, label: string) => {
    acc[label] = (...args: any) => css`
        @media (min-width: ${sizes[label]}px) {
            ${css(args)};
        }
    `;
    return acc;
}, {});
